var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('font-awesome-icon',{staticClass:"empty-state-icon",attrs:{"icon":['fal', _vm.icon]}}),_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"empty-state-description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }